// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.source-owner .ibox {
  margin-top: 20px;
}

.source-owner h2 {
  margin-bottom: 20px;
  font-weight: 500;
  font-family: "MuseoSans-300";
}
.source-owner h2 i {
  cursor: pointer;
}
.source-owner h2 i + i {
  margin-left: 8px;
}
.source-owner ul {
  max-width: 350px;
  width: 100%;
}
.source-owner ul li .source-wrapper__col2 {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
.source-owner ul li .source-wrapper__col2 > div {
  width: 50%;
  padding: 0 10px;
}
@media only screen and (max-width: 480px) {
  .source-owner ul li .source-wrapper__col2 > div {
    width: 100%;
  }
}
.source-owner ul li input,
.source-owner ul li select {
  margin-bottom: 12px;
  height: 34px;
}
.source-owner ul li input:focus, .source-owner ul li input:focus-visible,
.source-owner ul li select:focus,
.source-owner ul li select:focus-visible {
  outline: none;
  border: 1px solid #1ab394;
}
.source-owner ul li.source-wrapper__view {
  display: flex;
}
.source-owner ul li.source-wrapper__view > div {
  padding: 6px 10px;
}
.source-owner ul li.source-wrapper__view > div:first-child {
  font-weight: 700;
  width: 40%;
  min-width: 140px;
}
.source-owner ul li label {
  font-weight: 900;
}
.source-owner .source-wrapper__button {
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.source-owner .source-wrapper__button button {
  width: auto;
}
.source-owner .source-wrapper__button button + button {
  margin-left: 10px;
}

.red-text {
  color: red;
}

.pdf-modal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/admin-pdf/admin-pdf.component.scss"],"names":[],"mappings":"AACC;EACC,gBAAA;AAAF;;AAKC;EACC,mBAAA;EACA,gBAAA;EACA,4BAAA;AAFF;AAIE;EACC,eAAA;AAFH;AAIG;EACC,gBAAA;AAFJ;AAOC;EACC,gBAAA;EACA,WAAA;AALF;AAQG;EAGC,aAAA;EAEA,eAAA;EACA,eAAA;AANJ;AAQI;EACC,UAAA;EACA,eAAA;AANL;AAQK;EAJD;IAKE,WAAA;EALJ;AACF;AASG;;EAEC,mBAAA;EACA,YAAA;AAPJ;AASI;;;EAEC,aAAA;EACA,yBAAA;AANL;AAUG;EAGC,aAAA;AARJ;AAUI;EAQC,iBAAA;AAfL;AAQK;EACC,gBAAA;EACA,UAAA;EACA,gBAAA;AANN;AAcG;EACC,gBAAA;AAZJ;AAiBC;EACC,gBAAA;EACA,WAAA;EACA,cAAA;EAGA,aAAA;EAEA,eAAA;EAGA,yBAAA;AAfF;AAiBE;EACC,WAAA;AAfH;AAiBG;EACC,iBAAA;AAfJ;;AAqBA;EACI,UAAA;AAlBJ;;AAqBA;EACC,aAAA;AAlBD","sourcesContent":[".source-owner {\n\t.ibox {\n\t\tmargin-top: 20px;\n\t}\n}\n\n.source-owner {\n\th2 {\n\t\tmargin-bottom: 20px;\n\t\tfont-weight: 500;\n\t\tfont-family: \"MuseoSans-300\";\n\n\t\ti {\n\t\t\tcursor: pointer;\n\n\t\t\t&+i {\n\t\t\t\tmargin-left: 8px;\n\t\t\t}\n\t\t}\n\t}\n\n\tul {\n\t\tmax-width: 350px;\n\t\twidth: 100%;\n\n\t\tli {\n\t\t\t.source-wrapper__col2 {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-ms-flex-wrap: wrap;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\tmargin: 0 -10px;\n\n\t\t\t\t&>div {\n\t\t\t\t\twidth: calc(100% / 2);\n\t\t\t\t\tpadding: 0 10px;\n\n\t\t\t\t\t@media only screen and (max-width: 480px) {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tinput,\n\t\t\tselect {\n\t\t\t\tmargin-bottom: 12px;\n\t\t\t\theight: 34px;\n\n\t\t\t\t&:focus,\n\t\t\t\t&:focus-visible {\n\t\t\t\t\toutline: none;\n\t\t\t\t\tborder: 1px solid #1ab394;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.source-wrapper__view {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\n\t\t\t\t&>div {\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\twidth: 40%;\n\t\t\t\t\t\tmin-width: 140px;\n\t\t\t\t\t}\n\n\t\t\t\t\t// width: 60%;\n\t\t\t\t\tpadding: 6px 10px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tlabel {\n\t\t\t\tfont-weight: 900;\n\t\t\t}\n\t\t}\n\t}\n\n\t.source-wrapper__button {\n\t\tmax-width: 350px;\n\t\twidth: 100%;\n\t\tmargin: 0 auto;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap;\n\t\t-webkit-box-pack: end;\n\t\t-ms-flex-pack: end;\n\t\tjustify-content: flex-end;\n\n\t\tbutton {\n\t\t\twidth: auto;\n\n\t\t\t&+button {\n\t\t\t\tmargin-left: 10px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.red-text{\n    color: red;\n}\n\n.pdf-modal {\n\tdisplay: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
